import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { Skeleton } from "antd";
import useAccountSummary from "hooks/useAccountSummary";
import { useIdentity } from "context/auth";
import { centsToDollars, valueOrUnknown } from "util/helpers";

const AvailableBalance: FC = () => {
    const { accounts } = useIdentity();
    const { isLoading, data } = useAccountSummary(accounts[0]);

    const availableBalance = valueOrUnknown(
        data?.availableBalanceInCents,
        centsToDollars,
    );
    return (
        <>
            <Box fontSize="15.5cqw" fontWeight="bold">
                {isLoading ? <Skeleton.Input active /> : availableBalance}
            </Box>
            <Box fontSize={18} fontWeight="semibold" color="var(--dcs-blue)">
                Request Payout
            </Box>
        </>
    );
};

export default AvailableBalance;
